import { isEmpty } from '@/helpers/string.helpers'
import { Chat } from '@/redux/chat/types'
import { api } from '@/services/api'
import { findWebhookConfigByCompany } from '../../../_http/webhook'
import { EndServiceDTO } from './types'

export async function onEndServiceHook(currentChat: Chat, companyId: string) {
  try {
    const { config } = await findWebhookConfigByCompany(companyId)
    if (isEmpty(config)) return
    if (isEmpty(config?.onServiceEnd)) return
    const url = config.onServiceEnd
    const dto: EndServiceDTO = {
      chat: {
        id: currentChat.id,
        chatName: currentChat.chatName,
        ticket: currentChat.ticket,
        lastMessage: currentChat.lastMessage,
        unreadMessagesCount: currentChat.unreadMessagesCount,
        operators: currentChat.operators,
        requesterNumber: currentChat.requesterNumber,
        receiverNumber: currentChat.receiverNumber,
        startDate: currentChat.startDate,
        endDate: currentChat.endDate,
        duration: currentChat.duration,
        status: currentChat.status,
        createdAt: currentChat.createdAt,
        updatedAt: currentChat.updatedAt,
        type: 'EndServiceCallback'
      }
    }
    await api.post(url, dto)
  } catch (error) {
    console.log('onEndServiceHook error', error)
  }
}
